import {Injectable} from '@angular/core';
import {from, Observable} from 'rxjs';
import {WorkflowPositionView} from '../../../models/position.models';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PositionChangeModalComponent} from './position-change-modal.component';
import {BigWorkflowOffer} from '../../../models/workflow-create.models';

@Injectable({providedIn: 'root'})
export class OfferDetailPositionChangeModalService {

  constructor(private modalService: NgbModal) {
  }

  open(data: BigWorkflowOffer): Observable<WorkflowPositionView[]> {
    const modalRef = this.modalService.open(PositionChangeModalComponent, {windowClass: 'modal2-normal'});
    modalRef.componentInstance.data = data;
    return from(modalRef.result);
  }

}
